import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ReferencePolygonLeft = (props) => {
    const width = props.width ? props.width + 'px' : '7px';
    const height = props.height ? props.height + 'px' : '8px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 7 8"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M0.5 4L6.5 7.4641L6.5 0.535899L0.5 4Z" />
        </SvgStyled>
    );
};

export default ReferencePolygonLeft;
